import {get, post} from "./index.js";

const list_devices = async () => {
    return get(`/device/`);
}

const add_device = async (device) => {
    return post(`/device/add`, device);
}

const edit_device = async (device) => {
    const {uuid, ...edit} = device;
    return post(`/device/${uuid}/edit`, edit);
}

const delete_device = async (id) => {
    return post(`/device/${id}/delete`);
}

export {
    list_devices,
    add_device,
    edit_device,
    delete_device
}
